import { ListItemButton, ListItemIcon, ListItemText, SvgIconProps, useTheme } from "@mui/material";
import type { JSX } from "react";

export type SidebarItemProps = {
  selected: boolean;
  icon: (props: SvgIconProps) => JSX.Element;
  label: string;
  onClick?: () => void;
  testLabel: string;
  disabled?: boolean | undefined;
};

export const SidebarItem = ({
  selected,
  icon: Icon,
  label,
  onClick,
  testLabel,
  disabled,
}: SidebarItemProps): JSX.Element => {
  const theme = useTheme();
  const { selectedBackgroundColor, selectedBackgroundStartColor, selectedTextColor, textColor, background } =
    theme.sidebar;
  return (
    <ListItemButton
      onClick={!disabled ? onClick : undefined}
      data-cy={testLabel}
      disabled={disabled}
      sx={{
        display: "flex",
        flexDirection: "column",
        position: "relative",
        my: 1,
        p: 0,
        height: "80px",
        justifyContent: "center",
        ...(selected
          ? {
              backgroundColor: selectedBackgroundColor,
              color: selectedTextColor,
              borderLeft: `5px solid ${selectedBackgroundStartColor}`,
              "&:hover": {
                backgroundColor: selectedBackgroundColor,
              },
              "&:hover .MuiListItemIcon-root, &:hover .MuiListItemIcon-root svg": {
                color: background,
              },
              "&:hover .MuiTypography-root": {
                color: selectedTextColor,
              },
            }
          : {
              backgroundColor: "transparent",
              color: textColor,
              "&:hover": {
                backgroundColor: theme.semanticColors.sidebar.hoverBackground,
              },
            }),
        ...(onClick && !disabled && { cursor: "pointer" }),
      }}
    >
      <div>
        <ListItemIcon sx={{ display: "flex", justifyContent: "center" }}>
          <Icon
            sx={{
              height: "38px",
              width: "38px",
              color: selected ? background : textColor,
            }}
          />
        </ListItemIcon>
        <ListItemText
          primaryTypographyProps={{
            color: selected ? theme.sidebar.selectedTextColor : theme.sidebar.textColor,
            fontFamily: theme.sidebar.fontFamily,
            fontSize: theme.sidebar.fontSize,
            fontWeight: theme.sidebar.fontWeight,
            textAlign: "center",
          }}
          primary={label}
          sx={{ m: 0, display: "flex", justifyContent: "center" }}
        />
      </div>
    </ListItemButton>
  );
};
